import router from '@/router'
// import router from '@/router'
import menuService from '@/services/menu'

export default {
    namespaced: true,
    state: {
        menu: [],
        submenu: [],
        selectMainmenu: []
    },
    mutations:{
        setMenu(state,value){
            state.menu = value;
        },
        setSubMenu(state, value){
            state.submenu = value;
        },
        selected(state,value){
            state.selectMainmenu = value;
        }
    },
    actions:{
        getMenu({ commit }){
            menuService.getAll().then((response)=>{
                commit('setMenu', response)

                // var item = response.find(item => item.title === "Dashboard");
                // commit("setSubMenu", item.sub);
            });
        },
        selectMenu({commit,state}, selected){
            var item = state.menu.find(item => item.title === selected);
            // console.log(item.sub);
            commit("setSubMenu", item.sub);

            if(item.sub.length > 0 )
                router.push("/"+selected+"/"+item.sub[0].title)
        }
    },
    getters: {
        menu : state => {
            return state.menu
        },
        submenu : state =>{
            return state.submenu
        }
    }
}